// extracted by mini-css-extract-plugin
module.exports = {"createButton":"NewPayment_createButton__Yf2jd"};